<script>
    export let row = {};
</script>

{#if row.supervisor_input}
    {#each row.supervisor_input as input}
        <div>{input.comments}</div>
    {/each}
{/if}